import React, { FC } from 'react';
import { BrandHyperlink } from '../../../../../doctrine/components/button';
import { buildUrlWithParameters } from '../../../../../doctrine/utils/url-utils/urlUtils';
import styles from './home_top_title.module.scss';

type Props = {
  title: string;
  small_title: string;
  subtitle: string;
  button_text: string;
  button_link: string;
  pageName: string;
};

export const HomeTopTitle: FC<Props> = ({
  title,
  small_title,
  subtitle,
  button_text,
  button_link,
  pageName,
}) => (
  <div className={styles.container}>
    <h1 className={styles.title}>{title}</h1>
    <div className={styles.smallTitle}>{small_title}</div>
    <div className={styles.subtitle}>{subtitle}</div>
    <BrandHyperlink
      large
      href={buildUrlWithParameters(button_link, {
        sourcePage: pageName,
      })}
      iconRight="arrow_forward"
    >
      {button_text}
    </BrandHyperlink>
  </div>
);
